import React from "react";
import { Spin } from "antd";
import styles from "./global-loader.module.css";
import { useSelector } from "react-redux";

const GlobalLoader = () => {
  const { show, message } = useSelector(
    (state) => state.globalLoader
  );

  if (!show) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.box}>
        <Spin size="large" />
        {message && <p>{message}</p>}
      </div>
    </div>
  );
};

export default GlobalLoader;
